export default __webpack_public_path__ + "static/media/MigrationCentreBannerPattern.dbb9fa88.svg";